"use client";

import React from "react";
import { ViewportList } from "react-viewport-list";
import { MissionType } from "@/types";
import { Alert, AlertDescription, AlertTitle } from "@oreme/ui";
import { MissionLisItem } from "@/components";
import { useMission } from "@/hooks";
import { useTranslations } from "next-intl";

type MissionListProps = {
  data: MissionType[];
};

function MissionList({ data }: Readonly<MissionListProps>) {
  const t = useTranslations("mission.MissionList");
  const ref = React.useRef<HTMLDivElement | null>(null);
  const { mission, locateMission } = useMission();

  if (!data?.length) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center w-full h-full p-4">
        <Alert className="text-center border-0">
          <AlertTitle>{t("oops")}</AlertTitle>
          <AlertDescription className="text-muted-foreground">
            {t("notFound")}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  const setNewMission = (newMission: MissionType) => locateMission(newMission);

  const handleClick = (selectedItem: MissionType) => {
    if (selectedItem !== mission) setNewMission(selectedItem);
  };

  return (
    <div
      ref={ref}
      className="absolute inset-0 overflow-y-auto px-2 py-1 flex flex-col gap-1"
    >
      <ViewportList viewportRef={ref} items={data}>
        {(item) => (
          <MissionLisItem
            key={item.mission_num2}
            mission={item}
            active={item.mission_num2 === mission?.mission_num2}
            onClick={() => handleClick(item)}
          />
        )}
      </ViewportList>
    </div>
  );
}

export { MissionList };
